import { Card } from "antd";
import { useSelector } from "react-redux";
import { DollarOutlined, MailOutlined } from "@ant-design/icons";

import usage1 from "../../assets/svg/usage-1.svg";
import usage2 from "../../assets/svg/usage-2.svg";
import usage3 from "../../assets/svg/usage-3.svg";
import usage4 from "../../assets/svg/usage-4.svg";
import usage5 from "../../assets/svg/usage-5.svg";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const Usage = () => {
  const { isEmailSetupView, isLeadView, isCompanyView, isExecutiveView } =
    useContext(AuthContext);
  const usageLeadCount = useSelector(
    (state) => state?.CommonReducer?.usageleadcount
  );
  const usageaccountInfo = useSelector(
    (state) => state?.CommonReducer?.usageaccountInfo
  );

  return (
    <Card
      title={<div className="heading18px fw-bold">Usage</div>}
      className="rounded-2xl shadow-md border"
    >
      <div className="d-flex flex-column gap-20">
        {isLeadView && (
          <Card className="bg-white shadow">
            <div className="d-flex gap-20">
              <div className="d-flex align-items-center justify-content-center bg-DFFFDE h-54 w-54 rounded">
                <img src={usage2} alt="" />
              </div>
              <div>
                <div className="heading18px fw-bold">{usageLeadCount}</div>
                <div className="text-color-030334 heading13px fw-semibold">
                  Leads Created
                </div>
              </div>
            </div>
          </Card>
        )}
        {isEmailSetupView && (
          <Card className="bg-white shadow">
            <div className="d-flex gap-20">
              <div className="d-flex align-items-center justify-content-center bg-EDF6FF  h-54 w-54 rounded">
                <MailOutlined className="text-color-2f9dff heading24px" />
              </div>
              <div>
                <div className="heading18px fw-bold">
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.emailSentCountLimit -
                    usageaccountInfo[0]?.emailsentCount || 0}
                  /
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.emailSentCountLimit || 0}
                </div>
                <div className="text-color-030334 heading13px fw-semibold">
                  Remaining Send Email Credits
                </div>
              </div>
            </div>
          </Card>
        )}
        <Card className="bg-white shadow">
          <div className="d-flex gap-20">
            <div className="d-flex align-items-center justify-content-center bg-FFE9DB h-54 w-54 rounded">
              <img src={usage3} alt="" />
            </div>
            <div>
              <div className="heading18px fw-bold">
                {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                  ?.viewEmailCount - usageaccountInfo[0]?.viewEmailCount || 0}
                /
                {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                  ?.viewEmailCount || 0}
              </div>
              <div className="text-color-030334 heading13px fw-semibold">
                Remaining Email Credits
              </div>
            </div>
          </div>
        </Card>
        <Card className="bg-white shadow">
          <div className="d-flex gap-20">
            <div className="d-flex align-items-center justify-content-center bg-FFF7D8 h-54 w-54 rounded">
              <img src={usage4} alt="" />
            </div>
            <div>
              <div className="heading18px fw-bold">
                {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                  ?.viewMobileCount - usageaccountInfo[0]?.viewMobileCount || 0}
                /
                {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                  ?.viewMobileCount || 0}
              </div>
              <div className="text-color-030334 heading13px fw-semibold">
                Remaining Mobile Credits
              </div>
            </div>
          </div>
        </Card>
        {isCompanyView && (
          <Card className="bg-white shadow">
            <div className="d-flex gap-20">
              <div className="d-flex align-items-center justify-content-center bg-F8E8FF h-54 w-54 rounded">
                <img src={usage5} alt="" />
              </div>
              <div>
                <div className="heading18px fw-bold">
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.companyDownloadCount -
                    usageaccountInfo[0]?.downloadcount || 0}
                  /
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.companyDownloadCount || 0}
                </div>
                <div className="text-color-030334 heading13px fw-semibold">
                  Remaining Company Downloads
                </div>
              </div>
            </div>
          </Card>
        )}
        {isExecutiveView && (
          <Card className="bg-white shadow">
            <div className="d-flex gap-20">
              <div className="d-flex align-items-center justify-content-center bg-e8f5e9 h-54 w-54 rounded">
                <i className="fs-25  las la-user-clock text-2e7d32"></i>
              </div>
              <div>
                <div className="heading18px fw-bold">
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.employeeDownloadCount -
                    usageaccountInfo[0]?.downloadEmployeeCount || 0}
                  /
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.employeeDownloadCount || 0}
                </div>
                <div className="text-color-030334 heading13px fw-semibold">
                  Remaining Contact Downloads
                </div>
              </div>
            </div>
          </Card>
        )}
        {isLeadView && (
          <Card className="bg-white shadow">
            <div className="d-flex gap-20">
              <div className="d-flex align-items-center justify-content-center bg-muted h-54 w-54 rounded">
                <DollarOutlined className="heading20px" />
              </div>
              <div>
                <div className="heading18px fw-bold">
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.leadDownloadCount -
                    usageaccountInfo[0]?.downloadLeadCount || 0}
                  /
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.leadDownloadCount || 0}
                </div>
                <div className="text-color-030334 heading13px fw-semibold">
                  Remaining Lead Downloads
                </div>
              </div>
            </div>
          </Card>
        )}
        {isLeadView && (
          <Card className="bg-white shadow">
            <div className="d-flex gap-20">
              <div className="d-flex align-items-center justify-content-center bg-FFF7D8 h-54 w-54 rounded">
                <i className="heading24px text-warm left-company-menu-icons las la-users" />
              </div>
              <div>
                <div className="heading18px fw-bold">
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.leadCreationLimit -
                    usageaccountInfo[0]?.leadCreationCount || 0}
                  /
                  {usageaccountInfo[0]?.subscriptions?.subscriptionPackage
                    ?.leadCreationLimit || 0}
                </div>
                <div className="text-color-030334 heading13px fw-semibold">
                  Remaining Lead Creations
                </div>
              </div>
            </div>
          </Card>
        )}
      </div>
    </Card>
  );
};

export default Usage;
